import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { message, Modal } from "antd";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { userData } from "../store/slices/UserInfo";
import { allowedRoles } from "../components/icons/ApplicationColor";
import LoginAxios from "../api/LoginAxios";
import { processIframes } from "../IframeHelper";
import { resetNotifications } from "../store/slices/notificationSlice";
import Spinner from "../components/Spinner";
import { MIGRATION_REDIRECT_URL } from "../config";
import dayjs from "dayjs";

const ImpersonateLogin = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const dispatch = useDispatch();
  const history = useNavigate();
  const userInfo = useSelector((state) => state.user.data);
  const leftMenuNames = userInfo?.left_menu;
  useEffect(() => {
    dispatch(resetNotifications());
    handleLogout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const WrongPassword = () => {
    messageApi.open({
      type: "error",
      content: "Error Impersonating the user. Please try later",
      duration: 7,
    });
  };
  const csrfToken = getCookie("csrftoken");
  const ImpersonateAuthUser = async () => {
    try {
      const res = await LoginAxios.get("/auth-user/");
      dispatch(userData(res.data));
      const isAdmin = res.data.roles.some((app) =>
        allowedRoles.includes(app.key_name)
      );
      if (isAdmin) {
        localStorage.setItem("isAdmin", "true");
        //console.log("role set");
      } else {
        localStorage.removeItem("isAdmin");
      }
      const currentDate = dayjs().format("YYYY-MM-DD");
      const migrationDate = res.data?.organization?.migration_date ? res.data.organization.migration_date.split('T')[0] : null;
      if (res.data?.organization?.is_migrated && migrationDate && migrationDate <= currentDate) {
        Modal.confirm({
          title: "Migration Notice",
          content: (
            <span>
              This organization has been successfully migrated to our next-gen
              platform, <span style={{ color: "#1266a0" }}><b>Trainery</b></span>
              <span style={{ color: "#d55b49" }}><b>HCM</b></span>.<br/><br/>
              Please click <b>OK</b> to continue
            </span>
          ),
          okText: "OK",
          cancelButtonProps: { style: { display: "none" } },
          maskClosable: false,
          keyboard: false,
          onOk: () => {
            const email = res.data?.email;
            window.location.href = email
              ? `${MIGRATION_REDIRECT_URL}/login?email=${encodeURIComponent(email)}`
              : MIGRATION_REDIRECT_URL;
          },
        });
      } else {
        history("/ca-admin/organization/profile/dashboard");
      }
    } catch (err) {
      //console.log(err);
      WrongPassword();
      history("/logout");
    }
  };
  //console.log(csrfToken);
  const ImpersonateApi = async () => {
    //console.log("In impersonateApi");
    try {
      const values = {
        organization: localStorage.getItem("impersonateLoginID"),
      };
      const res = await LoginAxios.post("/impersonatelogin/", values, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      localStorage.setItem("token", res.data.token);
      localStorage.removeItem("isAdmin");
      localStorage.removeItem("superadmin");
      localStorage.removeItem("isOpen");
      ImpersonateAuthUser();
      //console.log(res);
    } catch (err) {
      WrongPassword();
      history("/admin-manager/clients");
    }
  };
  const handleLogout = async () => {
    //console.log("In handlelogout");
    try {
      await LoginAxios.get("/logout/");
      //console.log(res);
      await processIframes(leftMenuNames, dispatch);
      //console.log("finished  promises");

      ImpersonateApi();
    } catch (err) {
      WrongPassword();
      history("/admin-manager/clients");
    }
  };

  return (
    <div>
      {contextHolder}
      <Spinner />
    </div>
  );
};

export default ImpersonateLogin;
